import { getLocale } from './locale';

class TranslationIndex {

	constructor(options) {	
		const  { dependencies, locales, defaultLocale, translations } = options || {};

		this.defaultLocale = defaultLocale;
		this.locales = new Set(locales || []);
		
		this.translations = translations || {};
		this.dependencies = {};
		this.dependents = {};
		this.translators = {};
		
		if( dependencies ) {
			this.addDependencies(dependencies);
		} 
	}
			
	getLocale(locale)  {
		return getLocale(locale, [...this.locales], this.defaultLocale );
	}
	
	hasTranslationLocale( locale ) {
		return this.translations.hasOwnProperty(locale);
	}
	
	addDependencies(dependencies) {
		Object.entries(dependencies).forEach(([id, values]) => this.addDependency(id, values));	
	}
	
	addDependency(id, dependencies) {
		this.dependencies[id] = dependencies;
		
		for(let i = 0; i < dependencies.length; i++) {
			const dependency = dependencies[i]; 
			this.dependents[dependency] = this.dependents[dependency] || new Set();
			
			this.dependents[dependency].add(id);
		}
	}
	
	hasTranslation(locale, translation) {
		return this.hasTranslationLocale(locale) &&
			   this.translations[locale].hasOwnProperty(translation);
	}
	
	addTranslation(locale, identifier, translation) {
		if( !this.translations.hasOwnProperty(locale) ) {
			this.translations[locale] = {};
		}
		
		this.translations[locale][identifier] = translation;
		
		if( this.translators.hasOwnProperty(identifier) ) {
			this.translators[identifier].addLocale(locale, identifier, translation);
		}
	}	
	
	addTranslator(translation, translator) {
		this.translators[translation] = translator;
	}
	
	getTranslator(translation) {
		if( !translation ) {
			console.warn("No translation given");
		}
				
		return this.translators[translation];
	}
	
	getDependencies(id) {
		// create a copy
		const dependencies = this.dependencies[id] || [];		
		
		let result = new Set(dependencies);
		
		for(let i = 0; i < dependencies.length; i++) {
			const values = this.getDependencies(dependencies[i]);
			
			result = new Set([...result, ...values]);
		}
		
		return result;
	}
	
	getDependents(id) {
		
	}
	
	async update(options) {
		const { locale, translations } = options;
	
		// update index with updated values
		Object.keys(translations)
		.forEach(id => {
			if( !this.hasTranslation(locale, id) ) {
				this.addTranslation(locale, id, translations[id]);
			}		
		})
		
		for (const [id, translator] of Object.entries(this.translators)) {
			await translator.changeLanguage(locale);	  
		}
	}
	
	copyOf() {
        return new TranslationIndex({
			defaultLocale: this.defaultLocale, 
            locales: [...this.locales],
            translations: Object.assign({}, this.translations),
            dependencies: Object.assign({}, this.dependencies),
            dependents: Object.assign({}, this.dependents)
            // do not copy translators
        })
	}
}

export { 
	TranslationIndex
}